<template>
<div>
  <b-col xs=10 lg=11 md=12 sm=12 center >
  <!-- <h1>Home</h1> -->
  <b-img center :src="require('../assets/award.png')" fluid width="70rem" class="imagens"></b-img>
  <p class="text-center texthome">Há mais de 30 anos no mercado trazendo soluções em sistemas informatizados para perto de você.</p>
    <b-img center :src="require('../assets/handshake.png')" fluid width="90rem" class="imagens"></b-img>
  <p class="text-center texthome">Nosso objetivo é disponibilizar sistemas acessíveis, completos, com a vantagem do suporte personalizado, com atenção e confiança.</p>
  <!-- lampada -->
  <b-img center :src="require('../assets/idea.png')" fluid width="110rem" class="imagens"></b-img>
  <p class="text-center texthome">Nosso trabalho é diferenciado, pois desenvolvemos tecnologia própria e inovadora.</p>
   <!-- <b-img center :src="require('../assets/map.png')" fluid width="110rem" class="imagens"></b-img>
  <p class="text-center texthome">Por causa do nosso suporte extensivo e soluções personalizadas, limitamos nossa atuação profissional para trazer os nossos serviços exclusivamente para você em Porto Alegre e região metropolitana.</p> -->
  <b-img center :src="require('../assets/pergamin_logo_color2.svg')" fluid width="130rem" class="imagens"></b-img>
  <p class="text-center texthome">Atualmente, nosso principal produto são os sistemas Pergamin, disponíveis para implantação imediata. </p> 
  <b-col class="text-center"><b-button size="lg" href="http://pergamin.com.br" pill variant="outline-secondary">Saiba mais sobre o Pergamin</b-button></b-col>
  <p></p>
  <!-- <a  class="linkhome"></a>   -->
</b-col>
</div>
</template>

<script>
export default {

}
</script>

<style>
.imagens {
  padding-top: 2vh;
  padding-bottom: 2vh;
}
.texthome{
 color: rgb(100, 100, 100);
 font-size: 1.5rem;
 font-style: normal;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.linkhome{
 color: rgb(100, 100, 100);
 font-size: 1.5rem;
 text-decoration: underline;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
</style>